import { generatePath } from 'react-router-dom';

import { TAX_SERVICES } from '#client/constants/navItemsIds';
import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the tax services menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getTaxServicesMenu({
  businessEntityUuid, order
}) {
  return processMenu({
    title: 'Tax Services',
    itemId: TAX_SERVICES,
    icon: 'calculator-fill.svg',
    path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'tax-services' }),
    order
  });
}
